import { render, staticRenderFns } from "./StoreBanner.vue?vue&type=template&id=45baa61c&"
import script from "./StoreBanner.vue?vue&type=script&lang=js&"
export * from "./StoreBanner.vue?vue&type=script&lang=js&"
import style0 from "./StoreBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports